// Which checkout fields must never travel in a URL.
//
// The two-page checkout used to hand off state by letting the browser do a
// native GET submit on #shipping_form, which serialised every field — name,
// email, phone, street address — into the checkout URL, where it sat in the
// address bar, in browser history, and in any outbound referrer.
//
// Scope is the shipping -> checkout hop only. Downstream pages were never
// affected: render() rebuilds #urlparams from the passThruParams allowlist
// before proceedToBonuses() forwards it, so bonus/thankyou URLs never carried
// PII.
//
// This is a DENYLIST on purpose. An allowlist would silently drop affiliate
// and click-tracking params we do not know about yet, and broken attribution
// is a worse failure than the one we are fixing here.
//
// Pure module: no DOM, no storage, no config.

// Where the shipping -> checkout handoff is parked. sessionStorage, so it dies
// with the tab and never reaches the server, history, or a referrer header.
export const HANDOFF_STORAGE_KEY = 'knk_checkout_handoff';

export const DEFAULT_PII_FIELDS = [
	'cShipFName',
	'cShipLName',
	'cShipAddress1',
	'cShipAddress2',
	'cShipCity',
	'cShipState',
	'cShipZip',
	'cEmail',
	'cPhone2',
];

export function isPiiField(name, piiFields = DEFAULT_PII_FIELDS) {
	if (!name) return false;
	const lowered = String(name).toLowerCase();
	return piiFields.some((field) => String(field).toLowerCase() === lowered);
}

// pairs: an iterable of [name, value], e.g. from $.serializeArray() mapped, or
// URLSearchParams.entries(). Returns the two halves as plain objects.
export function partitionParams(pairs, piiFields = DEFAULT_PII_FIELDS) {
	const pii = {};
	const passThrough = {};

	Array.from(pairs || []).forEach(([name, value]) => {
		if (isPiiField(name, piiFields)) {
			pii[name] = value;
		} else {
			passThrough[name] = value;
		}
	});

	return { pii, passThrough };
}
